import { render, staticRenderFns } from "./LicenseOption.vue?vue&type=template&id=5666c8fa&"
import script from "./LicenseOption.vue?vue&type=script&lang=js&"
export * from "./LicenseOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports